
//import * as rst from "@alwicom/resist/dist/cjs/framework/wc/layout/rst-loginapp";
import * as rst from "@alwicom/resist";
import { RstLanguage, rst_resources } from "../_system/language/rst_resources";
//import { RstaLoginApp_001 } from "./rsta-loginapp_001";
    //import { RstLoginApp } from "@alwicom/resist";
    
    ////var loginAppUIView: RstLoginAppUIView_001;
    //var rstaLoginApp: RstaLoginApp_001;
    
    /**
    * Entry Point dell'applicativo (corrisponde a document ready)
    */
    window.addEventListener('DOMContentLoaded', (e) => {
        customElements.define('rst-loginapp', rst.RstLoginApp);
        
        SetResourcesFromCurrentCulture();
        
        rst.RstLoginApp.currentHtmlTemplate = `
        <style>
        @font-face {
            font-family: Poppins-Regular;
            src: url('/fonts/poppins/Poppins-Regular.ttf');
        }
        
        @font-face {
            font-family: Poppins-Medium;
            src: url('/fonts/poppins/Poppins-Medium.ttf');
        }
        
        @font-face {
            font-family: Poppins-Bold;
            src: url('/fonts/poppins/Poppins-Bold.ttf');
        }
        
        @font-face {
            font-family: Poppins-SemiBold;
            src: url('/fonts/poppins/Poppins-SemiBold.ttf');
        }
        
        * {
            margin: 0px;
            padding: 0px;
            box-sizing: border-box;
        }
        
        body, html {
            height: 100%;
            font-family: Poppins-Regular, sans-serif;
        }
        
        a {
            font-family: Poppins-Regular;
            font-size: 14px;
            line-height: 1.7;
            color: #666666;
            margin: 0px;
            transition: all 0.4s;
            -webkit-transition: all 0.4s;
            -o-transition: all 0.4s;
            -moz-transition: all 0.4s;
        }
        
        a:focus {
            outline: none !important;
        }
        
        a:hover {
            text-decoration: none;
            color: #a64bf4;
        }
        
        .container-login100 {
            width: 793px;
            min-height: 68vh;
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            flex-wrap: wrap;
            /* justify-content: center; */
            /* align-items: center; */
            /* padding: 150px; */
            background-repeat: no-repeat;
            background-position: center;
            /* background-size: cover; */
        }
        
        
        .wrap-login100 {
            position: absolute;
            top: 0px;
            bottom: 0px;
            width: 500px;
            right: 0px;
            background: #fff;
            /*border-radius: 10px;*/
            overflow: hidden;
            padding: 55px;
        }
        
        .login100-form-title {
            display: block;
            font-family: Poppins-Bold;
            font-size: 39px;
            color: #333333;
            line-height: 1.2;
            text-align: center;
        }
        
        .wrap-input100 {
            width: 100%;
            position: relative;
            border-bottom: 2px solid #d9d9d9;
        }
        
        .label-input100 {
            font-family: Poppins-Regular;
            font-size: 14px;
            color: #333333;
            line-height: 1.5;
            padding-left: 7px;
        }
        
        .input100 {
            font-family: Poppins-Medium;
            font-size: 16px;
            color: #333333;
            line-height: 1.2;
            display: block;
            width: 100%;
            height: 55px;
            background: transparent;
            padding: 0 7px 0 43px;
            border: 0px;
            outline: none;
        }
        
        
        /*---------------------------------------------*/
        .focus-input100 {
            position: absolute;
            display: block;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            pointer-events: none;
        }
        
        .focus-input100::after {
            /*content: attr(data-symbol);*/
            /*font-family: Material-Design-Iconic-Font;*/
            color: #adadad;
            font-size: 22px;
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            height: calc(100% - 20px);
            bottom: 0;
            left: 0;
            padding-left: 13px;
            padding-top: 3px;
        }
        
        .focus-input100::before {
            content: "";
            display: block;
            position: absolute;
            bottom: -2px;
            left: 0;
            width: 0;
            height: 2px;
            background: #7f7f7f;
            -webkit-transition: all 0.4s;
            -o-transition: all 0.4s;
            -moz-transition: all 0.4s;
            transition: all 0.4s;
        }
        
        
        .input100:focus + .focus-input100::before {
            width: 100%;
        }
        
        .has-val.input100 + .focus-input100::before {
            width: 100%;
        }
        
        .input100:focus + .focus-input100::after {
            color: #a64bf4;
        }
        
        .has-val.input100 + .focus-input100::after {
            color: #a64bf4;
        }
        
        .text-center {
            text-align: center;
        }
        
        .text-left {
            text-align: left;
        }
        
        .text-right {
            text-align: right;
        }
        
        .text-middle {
            vertical-align: middle;
        }
        
        .container-login100-form-btn {
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
        }
        
        .wrap-login100-form-btn {
            width: 100%;
            display: block;
            position: relative;
            z-index: 1;
            border-radius: 25px;
            overflow: hidden;
            margin: 0 auto;
            box-shadow: 0 5px 30px 0px rgba(3, 216, 222, 0.2);
            -moz-box-shadow: 0 5px 30px 0px rgba(3, 216, 222, 0.2);
            -webkit-box-shadow: 0 5px 30px 0px rgba(3, 216, 222, 0.2);
            -o-box-shadow: 0 5px 30px 0px rgba(3, 216, 222, 0.2);
            -ms-box-shadow: 0 5px 30px 0px rgba(3, 216, 222, 0.2);
        }
        
        .login100-form-bgbtn {
            position: absolute;
            z-index: -1;
            width: 300%;
            height: 100%;
            background: #a64bf4;
            background: -webkit-linear-gradient(right, #00dbde, #fc00ff, #00dbde, #fc00ff);
            background: -o-linear-gradient(right, #00dbde, #fc00ff, #00dbde, #fc00ff);
            background: -moz-linear-gradient(right, #00dbde, #fc00ff, #00dbde, #fc00ff);
            background: linear-gradient(right, #00dbde, #fc00ff, #00dbde, #fc00ff);
            top: 0;
            left: -100%;
            -webkit-transition: all 0.4s;
            -o-transition: all 0.4s;
            -moz-transition: all 0.4s;
            transition: all 0.4s;
        }
        
        .login100-form-btn {
            font-family: Poppins-Medium;
            font-size: 16px;
            color: #fff;
            line-height: 1.2;
            text-transform: uppercase;
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 20px;
            width: 100%;
            height: 50px;
            background-color: transparent;
            border: 0px;
            cursor: pointer;
        }
        </style>
        
        <div class="container-login100" style="background-image: url('./img/bg-momo-01.png');">
            
            <div class="wrap-login100">
                <span class="login100-form-title">
                Login
                </span>
                
                <div class="wrap-input100 m-b-23" style="margin-bottom:23px;" data-validate="Username is required">
                    <span class="label-input100">${rst_resources.rstuiUsername}</span>
                    <input id="rst_login_username" class="input100" type="text" name="username" placeholder="Type your username">
                    <!--<span class="focus-input100" data-symbol="&#xf206;"></span>-->
                    <span class="focus-input100" data-symbol="">
                    <i class="fa-solid fa-user" style="margin-top:40px;margin-left:10px;"></i>
                    </span>
                </div>
                
                <div class="wrap-input100" data-validate="Password is required">
                    <span class="label-input100">Password</span>
                    <input id="rst_login_password" class="input100" type="password" name="pass" placeholder="Type your password">
                    <!--<span class="focus-input100" data-symbol="&#xf190;"></span>-->
                    <span class="focus-input100" data-symbol="">
                    <i class="fa-solid fa-key" style="margin-top:40px;margin-left:10px;"></i>
                    </span>
                </div>
                
                <div id="rst_login_forgot_password" class="text-right" style="margin-top: 20px;">
                    <a href="#">
                    ${rst_resources.rstuiForgotPassword}
                    </a>
                </div>
                
                <div class="container-login100-form-btn" style="margin-top: 20px;">
                    <div class="wrap-login100-form-btn">
                        <div class="login100-form-bgbtn"></div>
                            <button id="rst_login_button" class="login100-form-btn">
                            Login
                            </button>
                        </div>
                    </div>
                    
                    <div class="rst-loginapp-wrong-password">
                    </div>
                    
                </div>
                
            </div>
            `;
            
            // 02. test con WC che deriva da RstAppLoginHTMLElement e quindi contiene tutta la logica di login, la riga seguente non è necessaria, ma la creo se servisse accedervi da qui
            document.querySelector("#rstAppLoginBody").innerHTML = `<rst-loginapp templatename="login_001_01" 2fa="true" forgotpassword="False" authenticatedpageurl="./app.html"></rst-loginapp>`;
            });
        
        
        function SetResourcesFromCurrentCulture() {
            var currentCultureSplit = GetCultureFromAgentBrowserOrCookie().split("-");
            if (currentCultureSplit != null && currentCultureSplit.length > 0) {
                var currentLanguageSelected = "rst_resources_" + currentCultureSplit[0];
                if (RstLanguage[currentLanguageSelected] != null)
                RstLanguage.Copy_rst_resources(RstLanguage[currentLanguageSelected]);
                
                rst.RstUiLanguage.Copy_rstui_resources(rst_resources);
            }
        }
        
        function GetCultureFromAgentBrowserOrCookie(): string {
            var currentCultureCookie = rst.JsHelper.GetCookie("X-Rst-CurrentCulture");
            if (rst.JsHelper.IsNullOrWhiteSpace(currentCultureCookie) == false) {
                return currentCultureCookie;
                } else {
                return navigator.language;
            }
        }
